import { HTTPClient } from "./Client";

const UsuarioApi = {

    async ObterUsuarioPorIdAsync(usuarioId) {
        const response = await HTTPClient.get(
            `/Usuario/ObterUsuarioPorId/${usuarioId}`
        );
        return response.data;
    },

    async ObterUsuarioPorEmailAsync(email) {
        const response = await HTTPClient.get(
            `/Usuario/ObterUsuarioPorEmail/${email}`
        );
        return response.data;
    },

    async ListarUsuariosAsync(statusUsuarioEnum) {
        const response = await HTTPClient.get(
            `/Usuario/ListarUsuarios?statusUsuarioEnum=${statusUsuarioEnum}`
        );
        return response.data;
    },

    async ListarUsuariosNaoInativosAsync() {
        const response = await HTTPClient.get(
            `/Usuario/ListarUsuariosNaoInativos`
        );
        return response.data;
    },

    async AdicionarUsuarioAsync(nomeCompleto, email, grupoDeUsuarioId) {
        const payload = {
            NomeCompleto: nomeCompleto,
            Email: email,
            GrupoDeUsuarioId: grupoDeUsuarioId
        };

        await HTTPClient.post(`/Usuario/AdicionarUsuario`, payload);
    },

    async TransformarLeadEmUsuarioAsync(nomeCompleto, email, leadId) {
        const payload = {
            NomeCompleto: nomeCompleto,
            Email: email,
            LeadId: Number(leadId)
        };

        const response = await HTTPClient.post(
            `/Usuario/TransformarLeadEmUsuario`,
            payload
        );

        return response.data;
    },

    async AtualizarUsuarioAsync(usuario) {
        const payload = {
            Id: usuario.usuarioID,
            NomeCompleto: usuario.nomeCompleto,
            Status: Number(usuario.status)
        };

        await HTTPClient.put(`/Usuario/AtualizarUsuario`, payload);
    },

    async DeletarUsuarioAsync(usuarioId) {
        await HTTPClient.put(`/Usuario/DeletarUsuario/${usuarioId}`);
    },

    async RestaurarUsuarioAsync(usuarioId) {
        await HTTPClient.put(`/Usuario/RestaurarUsuario/${usuarioId}`);
    },

    async BloquearUsuarioAsync(usuarioId) {
        await HTTPClient.put(`/Usuario/BloquearUsuario/${usuarioId}`);
    },

    async SuspenderUsuarioAsync(usuarioId) {
        await HTTPClient.put(`/Usuario/SuspenderUsuario/${usuarioId}`);
    },

    async ListarStatusUsuarioAsync() {
        const response = await HTTPClient.get(
            `/Usuario/ListarStatusUsuario`
        );
        return response.data;
    },

    async AlterarSenhaUsuarioAsync(id, senhaAtual, novaSenha, confirmarNovaSenha) {
        const payload = {
            Id: id,
            SenhaAtual: senhaAtual,
            NovaSenha: novaSenha,
            ConfirmarNovaSenha: confirmarNovaSenha
        };

        await HTTPClient.put(`/Usuario/AlterarSenhaUsuario`, payload);
    },

    async ListarUsuariosComPaginacaoAsync(pagina, nome, email) {
        const payload = {
            Pagina: pagina,
            Nome: nome,
            Email: email
        };

        const response = await HTTPClient.post(
            `/Usuario/ListarUsuariosComPaginacao`,
            payload
        );

        return response.data;
    },

    async ListarUsuariosPorGrupoDeUsuarioAsync(grupoDeUsuarioId) {
        const response = await HTTPClient.get(
            `/Usuario/ListarUsuariosPorGrupoDeUsuario/${grupoDeUsuarioId}`
        );
        return response.data;
    }
};

export default UsuarioApi;
